export default __webpack_public_path__ + "static/media/space_part4.c52e02d6.png";